import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1A1A1A",
      "fill-rule": "evenodd",
      d: "M21 20a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2zM6.293 13.293l11-11a1 1 0 0 1 1.32-.083l.094.083 3 3a1 1 0 0 1 .083 1.32l-.083.094-11 11a1 1 0 0 1-.576.284L10 18H7a1 1 0 0 1-.993-.883L6 17v-3a1 1 0 0 1 .206-.608zl11-11zM18 4.414l-10 10V16h1.586l10-10z"
    }, null, -1)
  ]))]))
}
export default { render: render }